<template>
  <div
    class="progress-bar"
    role="progressbar"
    :style="barStyle"
    :aria-valuenow="value"
    :aria-valuemin="0"
    :aria-valuemax="max"
  ><span v-if="label" class="progress-bar-label">{{ label }}</span></div>
</template>

<script>
export default {
  name: 'BProgressBar',
  inject: {
    progressMax: { default: 100 }
  },
  props: {
    value: { type: Number, default: 0 },
    label: { type: String, default: null },
    striped: { type: Boolean, default: false },
    animated: { type: Boolean, default: false }
  },
  computed: {
    max() {
      return this.progressMax || 100
    },
    barStyle() {
      const pct = (this.value / this.max) * 100
      const style = { width: pct + '%' }
      if (this.striped) {
        style.backgroundImage = 'linear-gradient(45deg, rgba(255,255,255,.15) 25%, transparent 25%, transparent 50%, rgba(255,255,255,.15) 50%, rgba(255,255,255,.15) 75%, transparent 75%, transparent)'
        style.backgroundSize = '1rem 1rem'
      }
      return style
    }
  }
}
</script>

<style scoped>
.progress-bar {
  position: relative;
  background-image: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0.20) 0%,
    rgba(255, 255, 255, 0) 50%,
    rgba(0, 0, 0, 0.06) 100%
  );
  background-blend-mode: overlay;
  transition: width 0.6s cubic-bezier(0.22, 1, 0.36, 1),
              background-color 0.5s ease;
  overflow: visible;
}

.progress-bar-label {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 0.65em;
  font-weight: 600;
  color: #fff;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.35);
  white-space: nowrap;
  pointer-events: none;
  letter-spacing: 0.02em;
  line-height: 1;
}
</style>
